import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FeedbackDialog } from "@/components/feedback/FeedbackDialog";
import masLogo from "@/assets/mas-logo.png";

export function Footer() {
  return (
    <footer className="border-t border-border bg-background/80 backdrop-blur-sm mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Logo and Info Section */}
          <div className="flex flex-col items-start gap-4">
            <img src={masLogo} alt="MAS" className="h-12 w-auto" />
            <div>
              <p className="text-xl font-black bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent">
                MAS Matrimonial
              </p>
              <p className="text-sm text-muted-foreground mt-2">
                A free community service by Muslim American Society DFW
              </p>
            </div>
          </div>

          {/* Contact Us Section */}
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-foreground">Contact Us</h3>
            <div className="space-y-2">
              <div className="flex items-start gap-2">
                <span className="text-sm font-medium text-foreground">Matchmakers:</span>
                <div className="flex items-center gap-1 text-sm text-muted-foreground">
                  <Mail className="h-3 w-3" />
                  <a href="mailto:matchmaker@masmatrimonial.com" className="hover:underline">matchmaker@masmatrimonial.com</a>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-sm font-medium text-foreground">Admin:</span>
                <div className="flex items-center gap-1 text-sm text-muted-foreground">
                  <Mail className="h-3 w-3" />
                  <a href="mailto:admin@masmatrimonial.com" className="hover:underline">admin@masmatrimonial.com</a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Admin Section */}
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-foreground">Support</h3>
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">
                Have feedback or need assistance?
              </p>
              <FeedbackDialog />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {new Date().getFullYear()} Muslim American Society DFW. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              <Link to="/privacy" className="hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <span aria-hidden="true">·</span>
              <Link to="/terms" className="hover:text-foreground transition-colors">
                Terms of Service
              </Link>
              <span aria-hidden="true">·</span>
              <Link to="/matchmaker/signup" className="hover:text-foreground transition-colors">
                Become a matchmaker
              </Link>
            </div>
            <p className="text-sm text-muted-foreground text-center md:text-right">
              Matchmakers from our community, doing things the traditional way
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
